import React from "react";
import { useLocation } from "react-router-dom";
import AdSlot from "./AdSlot";

const PATH_TO_KEY = {
  "/": "home",
  "/services": "services",
  "/portfolio": "portfolio",
  "/contact": "contact",
};

/**
 * Thin wrapper that renders the marquee-top slot for the current route.
 * Kept for backwards compatibility with PublicShell mounting.
 */
export default function MarqueePanel() {
  const { pathname } = useLocation();
  const pageKey = PATH_TO_KEY[pathname];
  if (!pageKey) return null;
  return <AdSlot page={pageKey} slot="marquee-top" />;
}
